import React from 'react'
import MyLabel from './MyLabel'
import { HiChevronUpDown } from 'react-icons/hi2'

export default function MySelect({
  register,
  name,
  errors,
  rules = {},
  options = [],
  label,
  labelSuffix,
  prefix,
  theme = 'light',
  onChange,
  defaultValue = {},
  placeholder = 'Select an option...',
}) {
  const themeClassMap = {
    white: 'tw-bg-white tw-border-gray-300',
    light: 'tw-bg-gray-100 tw-border-transparent',
    dark: 'tw-bg-gray-800 tw-border-transparent',
  }
  const themeClass = themeClassMap[theme] || 'tw-bg-gray-100 tw-border-transparent'

  // Check if defaultValue exists in options to avoid duplicates
  const defaultValueExists = options.some(option => option.value === defaultValue?.value)

  return (
    <div>
      <MyLabel text={label} textSuffix={labelSuffix}>
        <div>
          <div className="tw-flex tw-items-center">
            {prefix && <div>{prefix}</div>}
            <div className="tw-w-full tw-relative">
              {onChange ? (
                <select onChange={onChange} className={`myselect ${themeClass} tw-cursor-pointer`}>
                  <option value="">{placeholder}</option>
                  {options.map(({ label: _label, value: _value }) => (
                    <option key={_value} value={_value}>
                      {_label}
                    </option>
                  ))}
                </select>
              ) : (
                <select
                  {...register(name, rules)}
                  className={`myselect ${themeClass} tw-cursor-pointer tw-truncate`}
                  defaultValue={defaultValue?.value || ''}
                >
                  <option value="">{placeholder}</option>

                  {/* Only render defaultValue as separate option if it doesn't exist in options */}
                  {defaultValue?.value && !defaultValueExists && (
                    <option value={defaultValue.value}>
                      {defaultValue?.name || defaultValue?.label}
                    </option>
                  )}

                  {options.map(({ label: _label, value: _value }) => (
                    <option key={_value} value={_value}>
                      {_label}
                    </option>
                  ))}
                </select>
              )}
              <div className="tw-absolute tw-top-2 tw-right-1.5 tw-text-slate-400 tw-text-xl tw-pointer-events-none">
                <HiChevronUpDown />
              </div>
            </div>
          </div>
          {errors?.[name] && (
            <div className="tw-text-xs tw-text-red-600 tw-font-medium tw-mt-1">{errors[name]?.message}</div>
          )}
        </div>
      </MyLabel>
    </div>
  )
}